import Vue from "vue";
import {API_HOST} from "@/settings/server";
import $store from "@/store";
import axios from "axios";

class BalanceService{
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }
    get({organizationId}){
        return Vue.axios.get(`${API_HOST}/api/balance`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                organizationId: organizationId ? organizationId : null
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }
}

export default new BalanceService()
